const ToastrPlugin = {
  install (Vue, store) {
    Vue.prototype.$toast = {
      success: function (message) {
        store.commit('SHOW_MESSAGE', { message: message, type: 'success' })
      },
      info: function (message) {
        store.commit('SHOW_MESSAGE', { message: message, type: 'info' })
      },
      warning: function (message) {
        store.commit('SHOW_MESSAGE', { message: message, type: 'warning' })
      },
      error: function (message) {
        store.commit('SHOW_MESSAGE', { message: message, type: 'error' })
      }
    }
  }
}

export default ToastrPlugin
